import React from 'react';
import './App.css';

import Routes from './routes';

const App = () => <Routes />

export default App;



// WEBPACK FOOTER //
// ./src/App.js